import React, { Component } from "react";
import { NavLink } from "react-router-dom";
export default class Modal extends Component {
  render() {
    let modelStyle = {
      display: "block",
      backgroundColor: "rgba(0,0,0,0.8)",
    };
    const des = this.props.content;
    console.log(des[0]);
    return (
      <div className="modal show fade" tabindex="-1" style={modelStyle}>
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title head tran_color ">
                {this.props.title}
              </h3>
              <button
                type="button"
                className=" btn btn-secondary"
                onClick={this.props.hide}
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
            <div className="modal-body text-center">
              <video
                width="800"
                controls
                autoPlay={true}
                style={{ objectFit: "cover" }}
              >
                <source src={this.props.video} type="video/mp4" />
                <source src={this.props.video} type="video/ogg" />
                Your browser does not support the video tag.
              </video>
            </div>
            <ol>
              {des.map((val, idx) => {
                return <li className="d_color">{val}</li>;
              })}
            </ol>
            <div className="modal-footer">
              <NavLink
                to={this.props.live}
                className="btn-get-started main-color"
              >
                Live 🔥
              </NavLink>
              <NavLink
                to={this.props.github}
                className="btn-get-started main-color"
              >
                Source Code 👨‍💻
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
